import "../assets/index-93ad846c.css";
import { A as n } from "../chunks/actionText-60ff01d1.mjs";
import { G as i } from "../chunks/GenRandomId-cb9ccebe.mjs";
import { A as l } from "../chunks/ArrowRight-74a9fcb2.mjs";
import { n as o } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const r = {
  name: "NcActionTextEditable",
  components: {
    ArrowRight: l
  },
  mixins: [n],
  props: {
    /**
     * id attribute of the checkbox element
     */
    id: {
      type: String,
      default: () => "action-" + i(),
      validator: (e) => e.trim() !== ""
    },
    /**
     * disabled state of the text area
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * value attribute of the input field
     */
    value: {
      type: String,
      default: ""
    }
  },
  emits: [
    "input",
    "update:value",
    "submit"
  ],
  computed: {
    /**
     * determines if the action is focusable
     *
     * @return {boolean} is the action focusable ?
     */
    isFocusable() {
      return !this.disabled;
    },
    computedId() {
      return i();
    }
  },
  methods: {
    onInput(e) {
      this.$emit("input", e), this.$emit("update:value", e.target.value);
    },
    onSubmit(e) {
      if (e.preventDefault(), e.stopPropagation(), !this.disabled)
        this.$emit("submit", e);
      else
        return !1;
    }
  }
};
var d = function() {
  var t = this, a = t._self._c;
  return a("li", { staticClass: "action", class: { "action--disabled": t.disabled } }, [a("span", { staticClass: "action-text-editable", on: { click: t.onClick } }, [t._t("icon", function() {
    return [a("span", { staticClass: "action-text-editable__icon", class: [t.isIconUrl ? "action-text-editable__icon--url" : t.icon], style: { backgroundImage: t.isIconUrl ? `url(${t.icon})` : null } })];
  }), a("form", { ref: "form", staticClass: "action-text-editable__form", attrs: { disabled: t.disabled }, on: { submit: function(s) {
    return s.preventDefault(), t.onSubmit.apply(null, arguments);
  } } }, [a("input", { staticClass: "action-text-editable__submit", attrs: { id: t.id, type: "submit" } }), t.name ? a("label", { staticClass: "action-text-editable__name", attrs: { for: t.computedId } }, [t._v(" " + t._s(t.name) + " ")]) : t._e(), a("textarea", t._b({ class: ["action-text-editable__textarea", { focusable: t.isFocusable }], attrs: { id: t.computedId, disabled: t.disabled }, domProps: { value: t.value }, on: { input: t.onInput } }, "textarea", t.$attrs, !1)), a("label", { directives: [{ name: "show", rawName: "v-show", value: !t.disabled, expression: "!disabled" }], staticClass: "action-text-editable__label", attrs: { for: t.id } }, [a("ArrowRight", { attrs: { size: 20 } })], 1)])], 2)]);
}, c = [], u = /* @__PURE__ */ o(
  r,
  d,
  c,
  !1,
  null,
  "b0b05af8",
  null,
  null
);
const x = u.exports;
export {
  x as default
};
